'use client';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="en">
      <body style={{ fontFamily: 'system-ui, sans-serif', padding: '2rem', background: '#f5f5f5' }}>
        <div style={{ maxWidth: '400px', margin: '4rem auto', background: '#fff', borderRadius: '16px', padding: '24px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
          <h2 style={{ color: '#dc2626', fontSize: '18px', marginBottom: '12px' }}>Something went wrong</h2>
          <div style={{ background: '#f5f5f5', borderRadius: '8px', padding: '12px', fontSize: '12px', overflowWrap: 'break-word', maxHeight: '200px', overflow: 'auto' }}>
            <p style={{ fontWeight: 600 }}>{error.name}: {error.message}</p>
            {error.stack && (
              <pre style={{ marginTop: '8px', color: '#888', whiteSpace: 'pre-wrap', wordBreak: 'break-word', fontSize: '11px' }}>
                {error.stack.split('\n').slice(0, 8).join('\n')}
              </pre>
            )}
          </div>
          <div style={{ marginTop: '16px', textAlign: 'center' }}>
            <button
              onClick={reset}
              style={{ background: '#4f46e5', color: '#fff', border: 'none', borderRadius: '8px', padding: '8px 24px', fontSize: '14px', cursor: 'pointer' }}
            >
              Try again
            </button>
          </div>
          <p style={{ marginTop: '12px', textAlign: 'center', fontSize: '11px', color: '#999' }}>
            If this keeps happening, try clearing your browser cache.
          </p>
        </div>
      </body>
    </html>
  );
}
